import { TaxonomyBestSellersModel } from './taxonomyBestSellersModel';
import { TaxonomyCategoriesModel } from './taxonomyCategoriesModel';

export const models = {
    TaxonomyCategoriesModel,
    TaxonomyBestSellersModel
};
